// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { noop } from 'lodash/fp';
import { Button, PhoneNumber, WaitingIndicator } from '~/components/widgets';
import NumberedList from '~/components/widgets/numbered-list/';
import RemoveDevice from '~/components/widgets/remove-device';
import messages from '~/core/i18n/components/widgets/device-offline/intl';
import { OfflinePageLink, PhoneNumberStyles, RemoveDeviceOffset } from './styles';
import Connector from '~/core/components/widgets/device-offline/redux';

type Props = {
    deviceId: string,
    deviceInstructions: Array<string>,
    hiveHomeLink: string,
    hiveHomeLinkText: string,
    isRemovable: boolean,
    phoneNumber: string,
    placementGuideUrl: string,
    refresh: noop,
    showPhoneNumber: boolean
};

type State = {
    showExtendedSupport: boolean,
    refreshing: boolean
};

class OfflineComponent extends Component<Props, State> {
    state = {
        showExtendedSupport: false,
        refreshing: false
    };

    refresh = () => {
        const { refresh } = this.props;
        // Dispatch request all devices
        refresh();
        this.setState({
            refreshing: true
        });

        setTimeout(() => {
            this.setState({
                refreshing: false,
                showExtendedSupport: true
            });
        }, 5000);
    };
    render() {
        const {
            deviceId,
            deviceInstructions,
            hiveHomeLink,
            hiveHomeLinkText,
            isRemovable,
            phoneNumber,
            placementGuideUrl,
            showPhoneNumber
        } = this.props;

        const { refreshing, showExtendedSupport } = this.state;

        return (
            <div>
                <p>
                    <FormattedMessage {...messages.subheading} />
                </p>
                <NumberedList>
                    {deviceInstructions.map(msg => (
                        <FormattedMessage
                            {...messages[msg]}
                            key={msg}
                            values={{
                                break: <br />,
                                link: (
                                    <OfflinePageLink href={placementGuideUrl} target="_blank">
                                        <FormattedMessage {...messages.hubGuideLinkText} />
                                    </OfflinePageLink>
                                )
                            }}
                        />
                    ))}
                </NumberedList>

                <p>
                    <FormattedMessage {...messages.note} />
                </p>
                <div>
                    {showPhoneNumber &&
                        !showExtendedSupport && (
                            <Button disabled={refreshing} onClick={this.refresh}>
                                <FormattedMessage {...messages.refresh} />
                            </Button>
                        )}
                    {isRemovable && (
                        <RemoveDeviceOffset>
                            <RemoveDevice deviceId={deviceId} />
                        </RemoveDeviceOffset>
                    )}
                </div>

                <WaitingIndicator show={refreshing} />

                {showExtendedSupport && (
                    <div>
                        <p>
                            <FormattedMessage
                                {...messages.extendedSupport}
                                values={{
                                    hiveHomeLink: (
                                        <OfflinePageLink href={hiveHomeLink} target="_blank">
                                            {hiveHomeLinkText}
                                        </OfflinePageLink>
                                    )
                                }}
                            />
                        </p>
                        {phoneNumber && (
                            <PhoneNumberStyles>
                                <PhoneNumber phoneNumber={phoneNumber} />
                            </PhoneNumberStyles>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

const Offline = (props: *) => <Connector {...props} render={props => <OfflineComponent {...props} />} />;
export default Offline;



// WEBPACK FOOTER //
// ./src/components/widgets/device-offline/index.js